import React from 'react'
import Header from '../components/Header'
import HomeHero from '../components/HomeHero'
import BetaFeature from '../components/BetaFeature'
import Footer from '../components/Footer'

function Home({user}) {


return (
<>
<Header/>
<HomeHero user={user}/>
<BetaFeature/>
<Footer/>

</>
    )
}

export default Home